import { attachInAppMessageCSS as nt } from "../../ui/js/iam-css.js";
import ot from "../../util/browser-detector.js";
import { logInAppMessageHtmlClick } from "../log-in-app-message-html-click.js";
import { getUser as Q } from "../../Core/get-user.js";
import { InAppMessage } from "../index.js";
import { keys as or } from "../../util/code-utils.js";
import { OperatingSystems as rt } from "../../util/device-constants.js";
import { parseQueryStringKeyValues as ut } from "../../util/url-utils.js";
import { WindowUtils as H } from "../../util/window-utils.js";
export default function ct(t, e, n, o, r, s) {
  const u = document.createElement("iframe");
  u.setAttribute("title", "Modal Message"), r && (u.style.zIndex = r + 1);
  const i = e => {
      const n = e.getAttribute("href"),
        r = e.onclick;
      return s => {
        if (null != r && "function" == typeof r && !1 === r()) return;
        let i = ut(n).abButtonId;
        if (
          ((null != i && "" !== i) || (i = e.getAttribute("id")),
          null != n && "" !== n && 0 !== n.indexOf("#"))
        ) {
          const r =
              "blank" ===
              (e.getAttribute("target") || "").toLowerCase().replace("_", ""),
            c = o || t.openTarget === InAppMessage.OpenTarget.BLANK || r,
            l = () => {
              logInAppMessageHtmlClick(t, i, n), H.openUri(n, c, s);
            };
          c ? l() : t.he(u, l);
        } else logInAppMessageHtmlClick(t, i, n);
        return s.stopPropagation(), !1;
      };
    },
    c = (t, e, n) => {
      const o = `([\\w]+)\\s*=\\s*document.createElement\\(['"]${n}['"]\\)`,
        r = t.match(new RegExp(o));
      if (r) {
        const n = `${r[1]}.setAttribute("nonce", "${e}")`;
        return `${t.slice(0, r.index + r[0].length)};${n};${t.slice(
          r.index + r[0].length
        )}`;
      }
      return null;
    };
  if (
    ((u.onload = () => {
      let o = null;
      if (null != s) {
        (o = document.createElement("html")), (o.innerHTML = t.message);
        const e = o.getElementsByTagName("style");
        for (let t = 0; t < e.length; t++) e[t].setAttribute("nonce", s);
        const n = o.getElementsByTagName("script");
        for (let t = 0; t < n.length; t++) {
          n[t].setAttribute("nonce", s),
            (n[t].innerHTML = n[t].innerHTML.replace(
              /<style>/g,
              `<style nonce='${s}'>`
            ));
          const e = c(n[t].innerHTML, s, "script");
          e && (n[t].innerHTML = e);
          const o = c(n[t].innerHTML, s, "style");
          o && (n[t].innerHTML = o);
        }
      }
      u.contentWindow.focus(),
        u.contentWindow.document.write(o ? o.innerHTML : t.message);
      const r = u.contentWindow.document.getElementsByTagName("head")[0];
      if (null != r) {
        if ((nt(r), t.ye())) {
          const e = document.createElement("style");
          (e.innerHTML = t.css),
            (e.id = t.Ae()),
            null != s && e.setAttribute("nonce", s),
            r.appendChild(e);
        }
        const e = u.contentWindow.document.createElement("base");
        e.setAttribute("target", "_parent"), r.appendChild(e);
      }
      const l = u.contentWindow.document.getElementsByTagName("title");
      l.length > 0 && u.setAttribute("title", l[0].textContent);
      const a = {
          closeMessage: function() {
            t.he(u);
          },
          logClick: function() {
            const e = [t, ...arguments];
            logInAppMessageHtmlClick.apply(t, Array.prototype.slice.call(e));
          },
          display: {},
          web: {}
        },
        requestPushPermission = function() {
          return function() {
            const t = arguments;
            import("../../Push/request-push-permission.js").then(e => {
              e.requestPushPermission.apply(
                null,
                Array.prototype.slice.call(t)
              );
            });
          };
        },
        m = {
          requestImmediateDataFlush: function() {
            const t = arguments;
            import("../../Core/request-immediate-data-flush.js").then(
              ({ requestImmediateDataFlush: requestImmediateDataFlush }) => {
                requestImmediateDataFlush.apply(
                  null,
                  Array.prototype.slice.call(t)
                );
              }
            );
          },
          logCustomEvent: function() {
            const t = arguments;
            import("../../Core/log-custom-event.js").then(
              ({ logCustomEvent: logCustomEvent }) => {
                logCustomEvent.apply(null, Array.prototype.slice.call(t));
              }
            );
          },
          logPurchase: function() {
            const t = arguments;
            import("../../Core/log-purchase.js").then(
              ({ logPurchase: logPurchase }) => {
                logPurchase.apply(null, Array.prototype.slice.call(t));
              }
            );
          },
          unregisterPush: function() {
            const t = arguments;
            import("../../Push/unregister-push.js").then(
              ({ unregisterPush: unregisterPush }) => {
                unregisterPush.apply(null, Array.prototype.slice.call(t));
              }
            );
          },
          requestPushPermission: requestPushPermission(),
          changeUser: function() {
            const t = arguments;
            import("../../Core/change-user.js").then(
              ({ changeUser: changeUser }) => {
                changeUser.apply(null, Array.prototype.slice.call(t));
              }
            );
          }
        },
        f = function(t) {
          return function() {
            m[t].apply(null, Array.prototype.slice.call(arguments));
          };
        };
      for (const t of or(m)) a[t] = f(t);
      const p = [
          "setFirstName",
          "setLastName",
          "setEmail",
          "setGender",
          "setDateOfBirth",
          "setCountry",
          "setHomeCity",
          "setEmailNotificationSubscriptionType",
          "setLanguage",
          "addAlias",
          "setPushNotificationSubscriptionType",
          "setPhoneNumber",
          "setCustomUserAttribute",
          "addToCustomAttributeArray",
          "removeFromCustomAttributeArray",
          "incrementCustomUserAttribute",
          "setCustomLocationAttribute",
          "addToSubscriptionGroup",
          "removeFromSubscriptionGroup"
        ],
        d = function(t) {
          return function() {
            const e = Q();
            e[t].apply(e, Array.prototype.slice.call(arguments));
          };
        },
        g = {};
      for (let t = 0; t < p.length; t++) g[p[t]] = d(p[t]);
      a.getUser = function() {
        return g;
      };
      const h = { showFeed: e },
        b = function(e) {
          return function() {
            const n = arguments;
            t.he(u, function() {
              h[e].apply(null, Array.prototype.slice.call(n));
            });
          };
        };
      for (const t of or(h)) a.display[t] = b(t);
      const y = { registerAppboyPushMessages: requestPushPermission() },
        A = function(t) {
          return function() {
            y[t].apply(null, Array.prototype.slice.call(arguments));
          };
        };
      for (const t of or(y)) a.web[t] = A(t);
      if (
        ((u.contentWindow.appboyBridge = a),
        (u.contentWindow.brazeBridge = a),
        t.Ce !== InAppMessage.es.Pe)
      ) {
        const t = u.contentWindow.document.getElementsByTagName("a");
        for (let e = 0; e < t.length; e++) t[e].onclick = i(t[e]);
        const e = u.contentWindow.document.getElementsByTagName("button");
        for (let t = 0; t < e.length; t++) e[t].onclick = i(e[t]);
      }
      const j = u.contentWindow.document.body;
      if (null != j) {
        t.Ee() && (j.id = t.htmlId);
        const e = document.createElement("hidden");
        (e.onclick = a.closeMessage),
          (e.className = "ab-programmatic-close-button"),
          j.appendChild(e);
      }
      u.contentWindow.dispatchEvent(new CustomEvent("ab.BridgeReady")),
        -1 !== u.className.indexOf("ab-start-hidden") &&
          ((u.className = u.className.replace("ab-start-hidden", "")), n(u)),
        document.activeElement !== u && u.focus();
    }),
    (u.className =
      "ab-in-app-message ab-start-hidden ab-html-message ab-modal-interactions"),
    ot.OS === rt.$e)
  ) {
    const e = document.createElement("div");
    return (
      (e.className = "ab-ios-scroll-wrapper"), e.appendChild(u), (t.qe = e), e
    );
  }
  return (t.qe = u), u;
}
